import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/srv/app/layouts/default.vue").then(m => m.default || m)),
  error: defineAsyncComponent(() => import("/srv/app/layouts/error.vue").then(m => m.default || m)),
  kiosk: defineAsyncComponent(() => import("/srv/app/layouts/kiosk.vue").then(m => m.default || m)),
  login: defineAsyncComponent(() => import("/srv/app/layouts/login.vue").then(m => m.default || m))
}